<template>
  <section class="product" @click="onClick">
    <select-box
      v-if="showSelectBox"
      :selected="selected"
      class="select-box"
      @action="$emit('selectBox')"
    ></select-box>
    <div
      class="thumb"
      :class="{ border: displaySpecs.border }"
      :style="{
        backgroundImage: 'url(' + imageUrl(product) + ')'
      }"
    ></div>

    <div class="main">
      <div class="text">
        <p class="first">
          <span class="in-package" v-if="inPackage"></span
          ><span class="name"> {{ product.name }} </span>
        </p>
        <p>
          <span class="quantity" v-if="product.quantity"
            >{{ product.quantity }} x </span
          >{{ title }} - {{ collection }}
        </p>
        <p v-if="showSpecs">
          <span v-for="(value, name) in product.printSpecification" :key="name">
            <span class="title" v-if="name != 'title'">{{ name }}</span
            ><span class="spec" v-if="name != 'title'">{{ value }}</span>
          </span>
        </p>
      </div>
      <slot name="menu"></slot>
    </div>
  </section>
</template>

<script>
export default {
  props: ['product', 'inPackage', 'selected', 'showSelectBox', 'showSpecs'],
  methods: {
    imageUrl(prod) {
      if (!prod.id) {
        return ''
      } else if (prod.previewImage) {
        return `/media/print-store/${this.rootStore.user.printStore.id}/preview/${prod.previewImage}/140`
      } else if (prod.hasVariants && prod.variant) {
        return `/media/print-store/${this.rootStore.user.printStore.id}/preview/${prod.variant.previewImage}/140`
      } else if (prod.previews.length && prod.printSpecification.colors) {
        const defaultColor = prod.printSpecification.colors.default
        const defaultImg = prod.previews.find(
          (img) => img.colour === defaultColor
        )

        // const preview = this.value.previews[0]
        return `/media/print-store/${this.rootStore.user.printStore.id}/preview/${defaultImg.uuid}/140`
      } else if (prod.previews.length) {
        const image = prod.previews[0].uuid
        return `/media/print-store/${this.rootStore.user.printStore.id}/preview/${image}/140`
      } else {
        return ''
      }
    },
    onClick() {
      this.$emit('click')
    }
  },
  computed: {
    collection() {
      if (this.product.collections) {
        return this.product.collections[0].name
      } else {
        return ''
      }
    },
    displaySpecs() {
      if (this.product.displaySpecification) {
        return this.product.displaySpecification
      } else {
        return {}
      }
    },
    title() {
      return this.product.printSpecification
        ? this.product.printSpecification.title
        : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.product {
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  margin-bottom: 10px;
  cursor: pointer;
  align-items: center;

  &:hover .main {
    background-color: #e6e6e6;
  }

  .text p {
    padding: 0;
    line-height: 17px;
  }
}

.select-box {
  margin-right: 0;
  flex-shrink: 0;
  flex-grow: 0;
}
.thumb {
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin: 0 7px;
  flex-shrink: 0;
  &.border {
    border: 1px solid #efefef;
  }
}

.text {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  //padding: 10px 15px;
  overflow: hidden;

  p {
    font-size: 11px;
    font-style: italic;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .first {
    font-style: normal;
    font-size: 12px;
    font-weight: 500;

    .name {
      flex-grow: 1;
    }
  }

  .in-package {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 6px;
    background: var(--sub-color);
    margin-right: 3px;
    margin-bottom: 1px;
    flex-grow: 0;
    flex-shrink: 0;
  }
}

.main {
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  transition: background-color 0.5s;
  background-color: #f4f4f4;
  border-radius: 20px;
  height: 70px;
  padding: 10px 5px 0 15px;
}
.title {
  padding-right: 5px;
}
.spec {
  font-weight: 500;
  padding-right: 7px;
}

.quantity {
  font-weight: 500;
}
</style>
